import { render, staticRenderFns } from "./FaceFortBiometry.vue?vue&type=template&id=6f6f9540&scoped=true"
import script from "./FaceFortBiometry.vue?vue&type=script&lang=js"
export * from "./FaceFortBiometry.vue?vue&type=script&lang=js"
import style0 from "./FaceFortBiometry.vue?vue&type=style&index=0&id=6f6f9540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f9540",
  null
  
)

export default component.exports